import React, { useEffect, useState, useMemo } from 'react';
import CustomTable from '../../Table/CustomTable';
import {
  setInstrumentEvents,
  useGetPersonnel,
  useInstrumentEquipments,
  useInstrumentEvents,
  useInstrumentSettings,
  useInstrumentVendors
} from '../../../util/db';
import { SETTING_TYPE } from './DefineCategories';
import { Col, Form, Row } from 'react-bootstrap';
import { listEventColumnsFn } from '../TabEvents/Columns';
import { useAuth } from '../../../util/auth';
import { hasPermission } from '../utils';
import { RULES, SCREEN } from '../../../util/Constant';
import { alphaNumericSorter, renderMUIButtonWithPermissions } from '../../../util/util';

const ReassignEvents = () => {
  const auth = useAuth();
  const [fromResponsiblePartyId, setFromResponsiblePartyId] = useState();
  const [toResponsiblePartyId, setToResponsiblePartyId] = useState();

  const [status, setStatus] = useState();
  const [location, setLocation] = useState();

  const { data: events = [] } = useInstrumentEvents({
    responsiblePartyId: fromResponsiblePartyId,
    status: status
  });

  const { data: vendors = [] } = useInstrumentVendors();
  const { data: personnel = [] } = useGetPersonnel();
  const { data: instruments = [] } = useInstrumentEquipments();
  const { data: instrumentSettingsEventStatus = [] } = useInstrumentSettings(
    SETTING_TYPE.EVENT_STATUS
  );

  const { data: instrumentSettingsEventType = [] } = useInstrumentSettings(SETTING_TYPE.EVENT_TYPE);
  const { data: instrumentSettingsLocation = [] } = useInstrumentSettings(
    SETTING_TYPE.INSTRUMENT_LOCATION
  );

  const [permissionData, setPermissionData] = useState(null);

  useEffect(() => {
    if (Array.isArray(personnel) && personnel.length > 0) {
      const matchingUser = personnel.find((person) => person.email === auth.user?.email);
      if (matchingUser) {
        if (auth.permissionData) setPermissionData(auth.permissionData[matchingUser.permission]);
      }
    }
  }, [personnel, auth.user?.email, auth.permissionData]);

  const instrumentLocationMap = useMemo(() => {
    const map = new Map();

    instruments.forEach((instrument) => {
      if (instrument?.id) {
        map.set(instrument.id, instrument.location);
      }
    });

    return map;
  }, [instruments]);

  const eventsData = useMemo(() => {
    if (!location) return events;

    return events.filter((e) => {
      const instrumentLocation = instrumentLocationMap.get(e.instrumentName);
      return instrumentLocation === location;
    });
  }, [events, location, instrumentLocationMap]);

  const handleSubmit = async () => {
    if (!toResponsiblePartyId) {
      alert('Please select a destination Responsible Party !');
      return;
    }

    const selectedEvents = eventsData.filter((e) => rowSelectionModel.includes(e.id));

    if (selectedEvents.length === 0) {
      alert('Please select at least one event to update !');
      return;
    }

    try {
      await Promise.all(
        selectedEvents.map((e) =>
          setInstrumentEvents({ ...e, responsibleParty: toResponsiblePartyId })
        )
      );

      alert('Responsible Party updated successfully.');

      setFromResponsiblePartyId('');
      setToResponsiblePartyId('');
    } catch (error) {
      console.error('Error updating events:', error);
      alert('An error occurred while updating events. Please try again.');
    }
  };

  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  useEffect(() => {
    setRowSelectionModel([]);
  }, [location, status, fromResponsiblePartyId]);

  return (
    <>
      {hasPermission(permissionData, SCREEN?.INSTRUMENT_SETTINGS, RULES.VIEW) ? (
        <>
          <div className="filter">
            <div>
              <Row className="flex-end">
                <Form.Group as={Col}>
                  <Form.Label>Responsible Party</Form.Label>
                  <Form.Select
                    value={fromResponsiblePartyId}
                    onChange={(event) => setFromResponsiblePartyId(event.target.value)}
                  >
                    <option value="">All Responsible Party</option>
                    {personnel.sort(alphaNumericSorter).map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Assign To</Form.Label>
                  <Form.Select
                    onChange={(event) => setToResponsiblePartyId(event.target.value)}
                    value={toResponsiblePartyId}
                  >
                    <option value="">All Responsible Party</option>
                    {personnel
                      .sort(alphaNumericSorter)
                      ?.filter((p) => p?.id !== fromResponsiblePartyId)
                      .map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Event Status</Form.Label>
                  <Form.Select
                    onChange={(event) => setStatus(event.target.value || undefined)}
                    value={status || ''}
                  >
                    <option value="">All Event Status</option>
                    {instrumentSettingsEventStatus?.sort(alphaNumericSorter).map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Location</Form.Label>
                  <Form.Select
                    onChange={(event) => setLocation(event.target.value)}
                    value={location}
                  >
                    <option value="">All Location</option>
                    {instrumentSettingsLocation?.sort(alphaNumericSorter).map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group as={Col}>
                  {renderMUIButtonWithPermissions(
                    'Re-assign',
                    () => handleSubmit(),
                    SCREEN?.INSTRUMENT_SETTINGS,
                    RULES.UPDATE,
                    permissionData
                  )}
                </Form.Group>
              </Row>
            </div>
          </div>
          <div className="grid-view">
            <h3>List of events with selected Responsible Party</h3>
            <div className="table-box">
              <CustomTable
                data={eventsData?.map((row) => {
                  const dataInstrument = instruments.find((item) => item.id === row.instrumentName);
                  const dataStatus = instrumentSettingsEventStatus.find(
                    (item) => item.id === row.status
                  );
                  const eventType = instrumentSettingsEventType.find(
                    (item) => item.id === row.eventType
                  );
                  const location = instrumentSettingsLocation.find(
                    (item) => item.id === dataInstrument?.location
                  );
                  return {
                    ...row,
                    location: location?.name,
                    instrumentId: dataInstrument?.id,
                    instrumentName: dataInstrument?.name,
                    status: dataStatus?.name,
                    eventType: eventType?.name
                  };
                })}
                header={listEventColumnsFn({ vendors, personnel })}
                numberOfRows={20}
                sort={{ sorting: { sortModel: [{ field: 'eventNumber', sort: 'asc' }] } }}
                sx={{
                  '.MuiDataGrid-cell': {
                    minHeight: '52px !important'
                  },
                  '& .MuiDataGrid-iconButtonContainer[aria-label*="filter"]': {
                    display: 'none'
                  }
                }}
                checkboxSelection={hasPermission(
                  permissionData,
                  SCREEN?.INSTRUMENT_SETTINGS,
                  RULES.UPDATE
                )}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                  setRowSelectionModel(newRowSelectionModel);
                }}
                rowSelectionModel={rowSelectionModel}
              />
            </div>
          </div>
        </>
      ) : (
        <> </>
      )}
    </>
  );
};

export default ReassignEvents;
